module.exports = __webpack_public_path__ + "img/recolectamos.6d20a7bc.png";